import { useEffect, useState, useRef, RefObject } from 'react';

export default function useOnScreen(options: IntersectionObserverInit, ref?: RefObject<any>) {
  const observerRef = useRef<IntersectionObserver | null>(null);

  const [isOnScreen, setIsOnScreen] = useState(false);

  
  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      ([entry]) => setIsOnScreen(entry.isIntersecting),
      {
        ...options
      }
    );
  }, [options]);

  useEffect(() => {
    if (ref?.current) observerRef?.current?.observe(ref.current);

    return () => {
      observerRef?.current?.disconnect();
    };
  }, [ref]);

  return isOnScreen;
}

export function isInViewport(ref?: RefObject<any>,node : HTMLElement|null = null ,offset = 0) {
  if (!ref?.current) return false;
  const offsetTop = node?.getBoundingClientRect().top ?? 0;
  const offsetBottom = node?.getBoundingClientRect().bottom ?? window.innerHeight;
  const top = ref.current.getBoundingClientRect().top; 
  if(top < offsetTop - offset)
    return false;
  if(top > offsetBottom + offset)
    return false;
  return true;
}
